/** Org hosts serve only their own org's public pages. Pure strings for Convex, Next server and client. */

import { extractPortalSlugFromHost } from "../portal/portal_host";
import {
  buildStaffEntryOrigin,
  buildStaffOrgOrigin,
  extractStaffSlugFromHost,
  isUsableStaffSlug,
} from "./staff_host";

/** Org named by the host label (`<slug>.hausverwalter.ai`, `<slug>.portalzugang.de`); null otherwise. */
export function orgSlugOfHost(host: string | null | undefined): string | null {
  return extractStaffSlugFromHost(host) ?? extractPortalSlugFromHost(host);
}

/** Origin a foreign org's public page moves to; null = this host may serve it. */
export function foreignOrgPublicPageOrigin(
  hostOrgSlug: string | null,
  contentOrgSlug: string,
): string | null {
  const content = contentOrgSlug.trim().toLowerCase();
  if (hostOrgSlug === null || hostOrgSlug.toLowerCase() === content)
    return null;
  return isUsableStaffSlug(content)
    ? buildStaffOrgOrigin(content)
    : buildStaffEntryOrigin();
}

const PUBLIC_ORG_PATH_RE =
  /^\/(?:share\/booking|embed\/booking|help)\/([^/?#]+)/;

/** Org slug in `/share/booking/<slug>`, `/embed/booking/<slug>`, `/help/<slug>`; null elsewhere. */
export function orgSlugOfPublicPath(pathname: string): string | null {
  const match = PUBLIC_ORG_PATH_RE.exec(pathname);
  const raw = match?.[1];
  if (!raw) return null;
  let slug: string;
  try {
    slug = decodeURIComponent(raw).trim().toLowerCase();
  } catch {
    return null;
  }
  // `/share/booking/manage/<ref>` is a booking, not an org.
  if (slug === "manage" && pathname.startsWith("/share/booking/")) return null;
  return slug.length > 0 ? slug : null;
}

/** Same path on the right org host, or null. Middleware: slug paths on label hosts, no DB. */
export function foreignOrgPublicPathRedirect(
  host: string | null | undefined,
  pathname: string,
  search: string,
): string | null {
  const contentOrgSlug = orgSlugOfPublicPath(pathname);
  if (contentOrgSlug === null) return null;
  const origin = foreignOrgPublicPageOrigin(
    orgSlugOfHost(host),
    contentOrgSlug,
  );
  return origin === null ? null : `${origin}${pathname}${search}`;
}
